export enum HeaderHeights {
	XS = 42,
	S = 56,
	M = 98,
}
